

const meiyu = {
  state: {
    lockUserId:0,
    status:0,
  },

  mutations: {
    SET_MEI: (state, lockUserId) => {
        state.lockUserId = lockUserId
      },
    SET_STATUS: (state, status) => {
      state.status = status
    },
  },
  actions: {
    },

}

export default meiyu
